import { createSlice } from "@reduxjs/toolkit";
import { persist, sagaSlice } from "./sagaStore";

const initialState = {
  sidebarCollapsed: true,
};

const uiSlice: sagaSlice = createSlice({
  ...persist("ui", initialState),
  reducers: {
    setSidebarCollapsed(state, action) {
      state.sidebarCollapsed = action.payload;
    },
  },
});

export const { setSidebarCollapsed } = uiSlice.actions;
export default uiSlice.reducer;
